import { render, staticRenderFns } from "./AddStaffPopup.vue?vue&type=template&id=d6e74d80&scoped=true&"
import script from "./AddStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./AddStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AddStaffPopup.vue?vue&type=style&index=0&id=d6e74d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e74d80",
  null
  
)

export default component.exports